import useShared from "../../../../../shared/_common/_shared";

export default function RidgewaymarketsEmptyData(props) {
    const {title} = props;
    const {IconCommon} = useShared();

    return (
        <IconCommon iconName={"empty"} className={"empty-data"} title={title || "noData"}/>
    );
}
